import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { FrontPageState } from '../../../reducer';
import SectionErrorBoundary from './SectionErrorBoundary';

export default function StartSponsorsSection(): ReactElement {
  const { startSponsors, isLoading } = useSelector((state: FrontPageState) => ({
    startSponsors: state.startSponsors,
    isLoading: state.isLoading.indexOf('start_sponsors') !== -1,
  }));
  return (
    <SectionErrorBoundary name="StartSponsorsSection" message="">
      <section id="start-sponsors" className="start-section">
        <div className="section-title-container">
          <h2 className="section-title">
            <span className="section-title-text">Våra partners</span>
          </h2>
        </div>
        <div className="section-content content-container start-puffs">
          {isLoading && (
            <div className="media-feed-loader">
              <div className="cssload-container">
                <ul className="cssload-flex-container">
                  <li>
                    <span className="cssload-loading" />
                  </li>
                </ul>
              </div>
            </div>
          )}
          {startSponsors.items.map((item) => (
            <div key={item.id} className="start-puff front-puff content-bg" title={item.label}>
              <a href={item.link} title={item.linkLabel}>
                <div className="start-puff-image disable-select pointer-cursor" style={{ backgroundImage: `url('${item.image}')` }} />
              </a>
            </div>
          ))}
        </div>
      </section>
    </SectionErrorBoundary>
  );
}
